import { Pill } from "./Pill";

/**
 * ShinyButton — legacy name, kept so every existing call site adopts the new
 * official pill system without edits. The travelling gleam is retired per the
 * PAQVERO redesign (clean pill family replaces it).
 *
 * className → layout (margins, width, hover scale); contentClassName →
 * padding/typography overrides. variant → any Pill variant (default amber).
 * Use as="span" when nested inside another clickable element (hero cards).
 */
export function ShinyButton({ as, className = "", contentClassName = "", variant = "amber", children, ...props }) {
  return (
    <Pill as={as} variant={variant} className={`${className} ${contentClassName}`} {...props}>
      {children}
    </Pill>
  );
}
